import { Children, useCallback, useEffect, useState } from "react";
import { groupBy } from "lodash";

import MenuTitle from "../misc/MenuTitle";
import compassSvg from "../../../assets/media/icons/compass.svg";

import { getProducts } from "../../../services/productRequestServices";

const MenuButtonsList = ({ list }) => (
  <div className="d-flex flex-column">
    {Children.toArray(
      list.map((item) =>
        item.url ? (
          item.url.includes("http") ? (
            <a
              className="btn px-1 py-2 text-text-color text-end text-14"
              href={item.url}
              target="_blank"
              rel="noreferrer"
            >
              {item.title}
            </a>
          ) : (
            <a
              className="btn px-1 py-2 text-text-color text-end text-14"
              href={item.url}
            >
              {item.title}
            </a>
          )
        ) : (
          <span className="px-1 py-2 text-text-color text-end text-14">
            {item.title}
          </span>
        )
      )
    )}
  </div>
);

const HeaderProducts = () => {
  const [groupedProductsData, changeGroupedProductsData] = useState([]);

  const getGroupedProductsData = useCallback(() => {
    return getProducts().then(({ results }) =>
      changeGroupedProductsData(
        Object.values(groupBy(results, "product_group.id"))
      )
    );
  }, []);

  useEffect(() => {
    getGroupedProductsData();
  }, [getGroupedProductsData]);

  return (
    <div className="row m-0">
      {groupedProductsData.map((products) => (
        <div
          key={products[0].product_group.id}
          className="col-12 col-md-4 px-0 px-md-2 my-2"
        >
          <div className={"border border-blue rounded p-3 h-100"}>
            <MenuTitle
              iconSrc={compassSvg}
              text={`${products[0].product_group.title} (${products[0].product_group.latin_title})`}
            />
            <MenuButtonsList list={products} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default HeaderProducts;
